import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class CalendarEventsRefreshersStorage {
    eventsRefresher = new BehaviorSubject<boolean>(false);

    constructor() { }

    setEventsRefresher(value: boolean): void {
        this.eventsRefresher.next(value);
    }

    listenEventsRefresher(): Observable<boolean> {
        return this.eventsRefresher.asObservable();
    }
}
